/*
 ** JDQueue wiehag
 */

import { JoinedDimensions } from '../../../utils/models.js';
import { FormattedMessage } from 'react-intl';
import globalMessages from '../../../../config/globalMessages.js';

const zincFields = [
  { ...JoinedDimensions.fields.id, width: 0.5 },
  { ...JoinedDimensions.fields.group, width: 0.5 },
  { ...JoinedDimensions.fields.stackNum, width: 0.5 },
  { ...JoinedDimensions.fields.orderNumber, width: 1.0 },
  { ...JoinedDimensions.fields.rawDimensionsMM2, width: 0.9 },
  { ...JoinedDimensions.fields.planedDimensionsMM2, width: 0.9 },
  { ...JoinedDimensions.fields.woodType, width: 0.5 },
  { ...JoinedDimensions.fields.fournierGrade, width: 0.5 },
  { ...JoinedDimensions.fields.fournierQuality, width: 0.5 },
  { ...JoinedDimensions.fields.numLamellas, width: 0.5 },
  { ...JoinedDimensions.fields.zincDoneNumLamellas, width: 0.5 },
  { ...JoinedDimensions.fields.noFingerJointingNeeded, width: 0.5 },
  { ...JoinedDimensions.actions.moveUpNoCompareSchneider, width: 0.3 },
  { ...JoinedDimensions.actions.moveDownNoCompareSchneider, width: 0.3 },
  { ...JoinedDimensions.actions.editJDWithoutAdmin, width: 0.3 },
  { ...JoinedDimensions.actions.deleteConfirmRepairOrder, width: 0.3 }
];

const colorsZink = function (item) {
  if (item?.finishedProducingOnZinc) return 'rgba(24, 89, 41, 0.5)';
  if (item?.producingOnZinc)         return 'rgba(19, 101, 160, 0.5)';
  if (item?.skipDimension)           return 'rgba(97, 30, 66, 0.43)';
  return '#FFFFFF';
};

const groupColorsZink = {
  finishedProducingOnZinc: 'rgba(202, 255, 216, 0.5)',
  producingOnZinc: 'rgba(219, 240, 247, 0.5)'
};

const coloringFieldKeysZink = ['currentlyLoadingMaterialFor', 'producingOnZinc', 'finishedProducingOnZinc'];

const searchFilterOptions = [
  { value: 'id',          label: <FormattedMessage id="id"          defaultMessage="ID" /> },
  { value: 'orderNumber', label: <FormattedMessage id="orderNumber" defaultMessage="Order Number" /> }
];

const label = <FormattedMessage {...globalMessages.machine} identifier={'machine'} />;

const wiehag_config = {
  selectState: 'zink',
  zincFields,
  orderFields: zincFields,
  colors: colorsZink,
  groupColors: groupColorsZink,
  coloringFieldKeys: coloringFieldKeysZink,
  label,
  data: {
    emptyFromVacuumToZink: false,
    productionSequenceHashCode: '',
    status: null
  },
  selectView: true,
  searchFilterOptions,
  selectOptions: {
    zink: {
      string: 'Zink',
      data: zincFields,
      colors: colorsZink,
      groupColors: groupColorsZink,
      coloringFieldKeys: coloringFieldKeysZink,
      hiddenStatuses: ['pressing', 'planing/lks'],
      tableIndexVariable: 'jdPosition',
      showButtons: ['missing-lamella-request', 'extra-lamella-request']
    }
  }
};

export default wiehag_config;
